// extracted by mini-css-extract-plugin
module.exports = {"header":"UserStory_header__3lGFX","display_medal":"UserStory_display_medal__3t53K","medal":"UserStory_medal__2Zi1f","is_closed":"UserStory_is_closed__2ABQp"};